"use client";

import { INDUSTRY_PRESETS } from "@/lib/invoice/presets";
import { TEMPLATES } from "@/lib/invoice/templates";
import { cx } from "./ui";

// Gallery of industry starters for quotations: each fills the subject, scope lines,
// notes and terms (see presets.js).
export default function IndustryPicker({ onPick, value, compact, ids }) {
  return (
    <div className={cx("grid gap-3", compact ? "grid-cols-2 sm:grid-cols-3" : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4")}>
      {INDUSTRY_PRESETS.filter((p) => !ids || ids.includes(p.id)).map((p) => (
        <button
          key={p.id}
          type="button"
          data-testid={`preset-${p.id}`}
          onClick={() => onPick(p)}
          className={cx(
            "group flex items-start gap-3 rounded-xl border bg-white p-3 text-left transition hover:-translate-y-0.5 hover:shadow-card",
            value === p.id ? "border-brand-600 ring-2 ring-brand-100" : "border-slate-200 hover:border-slate-300"
          )}
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-slate-50 text-xl ring-1 ring-slate-100 group-hover:bg-brand-50">{p.icon}</span>
          <span className="min-w-0">
            <span className="block text-sm font-semibold text-slate-900">{p.label}</span>
            <span className="block text-xs leading-snug text-slate-500">{p.desc}</span>
            {!compact && (
              <span className="mt-1.5 block text-[11px] text-slate-400">
                {p.items.length} lines · {p.terms.length} terms{p.template ? ` · ${TEMPLATES[p.template]?.label} design` : ""}
              </span>
            )}
          </span>
        </button>
      ))}
    </div>
  );
}
